<template  >
  <div class="root"  @keydown.enter="logindo">
    <div class="login-container">
      <Form ref="loginForm" :model="loginForm" :rules="ruleValidate" label-position="left" :label-width="20" >
        <FormItem class="title">
          <h3>系统登陆</h3>
        </FormItem>
        <FormItem  prop="username">
          <Input placeholder="输入登陆账号" size="large" v-model="form.user"></Input>
        </FormItem>
        <FormItem prop="password">
          <Input type="password" placeholder="输入登陆密码"  size="large" v-model="form.password"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" long  size="large"  @click="logindo" :disabled="loading">登陆</Button>
        </FormItem>
      </Form>
    </div>

    <table>
      <tr style="font-weight: bold;text-align: center">
        <td colspan=""></td>
      </tr>
    </table>
  </div>
</template>

<script>
  export default {
    name:'login',
    data(){
      return{
        loading:false,
        check:false,
        form:{
          user:'',
          password:'',
        }
      }
    },
    methods:{
      logindo(){
        this.loading = true;
        let that = this;
        const data = this.$qs.stringify({
          username: this.form.user || '',
          password: this.form.password || ''
        });
        this.$axios.post('/api/monitor/auth/login', data).then(function(rs){
          that.redirect(rs.data);
          that.loading = false;
        }).catch(function(){
          that.loading = false;
        });
      },
      redirect(data){
        if(data.success){
          if(data.data && data.data.username){
            this.$storage.setSession('monitorUser',data.data.username);
            this.$Message.success(data.msg);
            this.$router.push({path:'/'});
          }else{
            alert('系统异常');
          }
        }else{
          this.$Message.error(data.msg+'，请检查账号密码');
        }
      },
    },
    created(){
      this.$Spin.hide();
    }
  }
</script>

<style scoped>
  .login-container {
    background-color:#F5F6F7;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin:0 auto;
    margin-top:10%;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    box-shadow: 0 0 25px #cac6c6;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue